import  './cta.css'

const CTA = () => {
  return (
    <div className='container'>
      <div className="left">
        <div className="sm-title">
          <p>Request Early Access to Get Started</p>
        </div>
        <div className="cta-title">
          <h1>Register today & start exploring the endless possiblities.</h1>
        </div>
      </div>
      <div className="right">
        <button>Get Started</button>
      </div>
    </div>
  )
}

export default CTA
